import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for J502 (Sample Receipt Approval)
// ============================================================

export interface PendingItem {
  fj120_01: string;        // 繳庫單號
  fj120_11: string | null; // 繳庫日期 (ISO string)
  fj120_12: string;        // 繳庫庫位代號
  warehouse_name: string;  // 庫位名稱
  fj120_14: string;        // 部門代號
  dept_name: string;       // 部門名稱
  fj120_15: number;        // 明細筆數
  fj120_10: string;        // 來源申請單號
  can_approve: boolean;    // 是否可核准
}

export interface QueryResponse {
  items: PendingItem[];
  total: number;
}

export interface ApproveResultItem {
  receipt_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const j502Api = {
  /** Query pending sample receipt items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/j502/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch approval for selected sample receipt items */
  async execute(receiptNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/j502/execute', {
      receipt_nos: receiptNos,
      confirmed: true,
    });
    return res.data;
  },
};
